import { render, staticRenderFns } from "./FishDetail.vue?vue&type=template&id=6bb953d2&scoped=true"
import script from "./FishDetail.vue?vue&type=script&lang=js"
export * from "./FishDetail.vue?vue&type=script&lang=js"
import style0 from "./FishDetail.vue?vue&type=style&index=0&id=6bb953d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb953d2",
  null
  
)

export default component.exports